<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <section class="container">
        <div class="">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30" style="margin-top: 35px">
                <div class="card-body">
                  <div class="text-center">
                    <h1 class="h3">
                      <strong>Formal Enrollee Biodata Form </strong>
                    </h1>
                    <p>
                      (All fields marked with
                      <span class="text-danger">*</span> are compulsory)
                    </p>
                  </div>
                  <form @submit.prevent="submitForm">
                    <div class="form-row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="inputCity">Select Sector
                            <span class="text-danger">*</span></label>
                          <select class="form-control" v-model="sector" disabled>
                            <option value="Formal">Formal Sector</option>
                            <option value="Informal">Informal Sector</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-6" v-if="sector == 'Formal'">
                        <div class="form-group">
                          <label for="inputCity">Select Sub-Formal Sector</label>
                          <select class="form-control" v-model="register.sector" required>
                            <option :value="sector" v-for="sector in sectors" :key="sector">
                              {{ sector }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">Enter Computer Number
                          <span class="text-danger">*</span></label>
                        <input type="text" required class="form-control" v-model="check_computer_number"
                          placeholder="Enter Computer Number" @change="checkEnrollee" />
                      </div>
                    </div>

                    <div class="row" v-show="showform">
                      <div class="form-group col-md-6">
                        <label>Select Enrollee </label>
                        <select class="form-control" v-model="selected_enrollee" @change="checkEnrollee">
                          <option :value="user" v-for="user in validated_enrollee" v-bind:key="user">
                            <span v-if="
                                register.sector != 'Universal Basic Education'
                              ">
                              {{ user.firstname }} {{ user.lastname }}</span>
                            <span v-if="
                                register.sector == 'Universal Basic Education'
                              ">
                              {{ user.FullName }}</span>
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">Full Name</label>
                        <input type="text" class="form-control" disabled v-model="register.FullName"
                          placeholder="Full Name" />
                        <p class="text-warning">Name here not uploaded</p>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Means of Identification
                          <span class="text-danger">*</span></label>
                        <select disabled class="form-control" v-model="register.means_of_id">
                          <option value="NIN Number">NIN Number</option>
                          <!-- <option value="Voter's Card">Voter's Card</option>
                          <option value="Driver's License">
                            Driver's License
                          </option>
                          <option value="International Passport">
                            International Passport
                          </option> -->
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">NIN <span class="text-danger">*</span></label>
                        <input required type="text" pattern="\d*" maxlength="11" class="form-control"
                          v-model="register.nimc_number" placeholder="NIN Number" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Surname <span class="text-danger">*</span></label>
                        <input type="text" disabled required class="form-control" v-model="register.lastname"
                          placeholder="Last Name" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputEmail4">First Name <span class="text-danger">*</span></label>
                        <input type="text" disabled required class="form-control" v-model="register.firstname"
                          placeholder="First Name" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Middle Name</label>
                        <input type="text" class="form-control" v-model="register.middlename" placeholder="Last Name" />
                      </div>

                      <div class="form-group col-md-6" v-if="sector == 'Formal'">
                        <label for="inputEmail4">Computer Number</label>
                        <input type="text" disabled required class="form-control" v-model="register.salary_number"
                          placeholder="Computer Employment Number" />
                      </div>

                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <p>
                            <label for="inputPassword4">Date of Birth
                              <span class="text-danger">*</span></label>
                          </p>
                          <input type="date" class="form-control" required v-model="register.dob" />
                        </div>
                        <div class="form-group col-md-6" v-if="sector == 'Formal'">
                          <label for="inputEmail4">Email</label>
                          <input type="email" class="form-control" v-model="register.email" placeholder="Email" />
                        </div>

                        <div class="form-group col-md-6">
                          <label for="inputPassword4">Phone Number<span class="text-danger">*</span></label>
                          <input v-phone type="text" class="form-control" required v-model="register.phone_number"
                            placeholder="Phone Number" />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="inputCity">Gender <span class="text-danger">*</span></label>
                          <select class="form-control" v-model="register.gender" required>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>

                        <div class="form-group col-md-6" v-if="sector == 'Formal'">
                          <label for="inputCity">Select MDA
                            <span class="text-danger">*</span></label>

                          <v-select v-model="register.place_of_work" :options="mdas" required label="name"></v-select>
                        </div>

                        <div class="form-group col-md-6">
                          <label>Marital Status</label>
                          <select class="form-control" v-model="register.marital_status">
                            <option value="Married">Married</option>
                            <option value="Widow">Widow</option>
                            <option value="Single">Single</option>
                            <option value="Separated">Separated</option>
                            <option value="Divorced">Divorced</option>
                          </select>
                        </div>

                        <div class="form-group col-md-6">
                          <label for="inputCity">State of Origin </label>

                          <select class="form-control" v-model="register.state_of_origin" @change="fetchLgaOrigin()">
                            <option v-for="state in states" v-bind:key="state.id" :value="state.id">
                              {{ state.name }}
                            </option>
                          </select>
                        </div>
                        <div class="form-group col-md-6">
                          <label for="inputCity">LGA of Origin</label>
                          <select class="form-control" v-model="register.lga_of_origin">
                            <option v-for="lga in lga_states_origin" v-bind:key="lga" :value="lga.local_name">
                              {{ lga.local_name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group col-md-6">
                          <label for="inputCity">LGA of Residence<span class="text-danger">*</span></label>
                          <select class="form-control" required v-model="register.localgovt" @change="fetchWards">
                            <option v-for="lga in lga_states" v-bind:key="lga" :value="lga">
                              {{ lga.local_name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group col-md-6">
                          <label>Ward of Residence
                            <span class="text-danger">*</span></label>
                          <select class="form-control" required v-model="register.ward"
                            @change="getProvidersByWards($event)">
                            <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                              {{ ward.ward_name }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-12 row">
                          <div class="form-group col-md-6">
                            <label>Principal Facility for Accessing Health Care
                              <span class="text-danger">*</span></label>
                            <v-select v-model="register.provider_id" :options="providers" required label="agency_name"
                              :value="register.provider_id" @input="selected"></v-select>
                          </div>
                          <div class="form-group col-md-6">
                            <label>
                              Alternate Facility for Accessing Health Care
                              <span class="text-danger">*</span></label>
                            <v-select v-model="register.point_of_care" required :options="providers" label="agency_name"
                              :value="register.point_of_care" @input="selectedPointocare"></v-select>
                          </div>
                        </div>

                        <div class="form-group col-md-12">
                          <label for="inputAddress">Home Address </label>
                          <input type="text" class="form-control" v-model="register.address"
                            placeholder="1234 Main St" />
                        </div>
                      </div>

                      <div class="col-md-12" v-if="
                          register.provider_id != null &&
                          register.point_of_care != null
                        ">
                        <button class="btn btn-info btn-block" type="submit">
                          Submit <i class="fe fe-send"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
            </div>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";

  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";

  import allFormalSectorState from "./../../../public/offline/civil_servant_state.json";
  import allFormalSectorLGA from "./../../../public/offline/civil_servant_lga.json";
  import NewFormalSectorLGA from "./../../../public/offline/new_lga_workers_data.json";
  import OPSStaff from "./../../../public/offline/ops_staff.json";

  export default {
    components: {
      Loading,
      Navbar,
    },
    data() {
      return {
        isLoading: false,
        fullPage: true,
        states: "",
        show: false,
        showform: false,
        clients: "",
        providers: "",
        check_computer_number: "",
        validated_enrollee: "",
        selected_enrollee: null,
        sector: "Formal",
        mdas: [],
        sectors: [
          "State Civil Servant",
          "LGA Civil Servant",
          "Universal Basic Education",
          "Organized Private Sector",
        ],
        wards: "",
        providers_wards: "",
        state: "",
        OfficerDetails: "",
        current_page: "",
        selected_provider: "",
        selected_provider_dependents: "",
        lga_states: "",
        lga_states_origin: "",
        all_formal_workers_state: allFormalSectorState,
        all_formal_workers_lga: allFormalSectorLGA,
        ubec_formal_workers_lga: NewFormalSectorLGA,
        ops_staff: OPSStaff,
        register: {
          FullName: "",
          firstname: "",
          lastname: "",
          middlename: "",
          nimc_number: "",
          means_of_id: "NIN Number",
          state_of_origin: "",
          lga_of_origin: "",
          email: "",
          phone_number: "",
          type: "client",
          agency_id: "",
          state: "",
          localgovt: "",
          ward: "",
          address: "",
          blood: "",
          weight: "",
          special_need: "",
          gender: "",
          genotype: "",
          dob: "",
          salary_number: "",
          provider_id: "",
          point_of_care: "",
          sector: "",
          finger_print: "",
          place_of_work: "",
          grade_level: "",
          date_of_entry: "",
          marital_status: "",
          category_of_vulnerable_group: "",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    computed: {},
    methods: {
      checkEnrollee() {
        this.isLoading = true;
        let total_total = [];
        if (this.register.sector == "State Civil Servant") {
          total_total = this.all_formal_workers_state;
        }

        if (this.register.sector == "LGA Civil Servant") {
          total_total = this.all_formal_workers_lga;
        }

        if (this.register.sector == "Universal Basic Education") {
          total_total = this.ubec_formal_workers_lga;
        }
        if (this.register.sector == "Organized Private Sector") {
          total_total = this.ops_staff;
        }


        let formatter = total_total.filter(
          (x) => x.CompNo == this.check_computer_number
        );
        console.log(formatter);
        this.validated_enrollee = formatter;
        let enrollee = this.selected_enrollee;
        if (this.validated_enrollee != null) {
          this.isLoading = false;
          this.showform = true;
          this.$toasted.success(`User Fetched Successfully!`, {
            position: "top-center",
            duration: 3000,
          });

          //split full name into firstname and lastname
          // if (
          //   this.selected_enrollee != null &&
          //   this.register.sector == "Universal Basic Education"
          // ) {
          //   let fullName = enrollee.FullName;
          //   let names = fullName.split(" ");
          //   enrollee.firstname = names[0];
          //   enrollee.lastname = names[1];

          //   console.log(enrollee); 
          // } else {
          // }

          enrollee.FullName = enrollee.firstname + " " + enrollee.lastname;


          this.updateForm(enrollee);
        } else {
          this.isLoading = false;
          this.showform = false;
          this.$toasted.error(`Enerollee not found`, {
            position: "top-center",
            duration: 3000,
          });
        }
      },
      updateForm(enrollee) {
        this.register.firstname = enrollee.firstname;
        this.register.lastname = enrollee.lastname;
        this.register.middlename = enrollee.middlename;
        this.register.salary_number = enrollee.CompNo;
        this.register.phone_number = enrollee.phone_number;
        this.register.phone_number = enrollee.phone_number;
        // this.register.means_of_id = enrollee.means_of_id;
        this.register.nimc_number = enrollee.nin_number;
        this.register.marital_status = enrollee.marital_status;
        this.register.email = enrollee.email;

        this.register.FullName = enrollee.FullName;
      },
      selected(value) {
        this.selected_provider = value.id;
      },
      selectedPointocare(value) {
        this.selected_provider_dependents = value.agency_name;
      },
      // this.selected_provider || this.register.provider_id == '' && this.selected_provider_dependents|| this.register.point_of_care == '' &&
      submitForm() {
        if (
          this.register.firstname == "" ||
          this.register.lastname == "" ||
          this.register.phone_number == "" ||
          this.register.gender == "" ||
          this.register.localgovt == "" ||
          this.register.ward == "" ||
          this.register.sector == ""
        ) {
          this.$toasted.error("Fill all required fields!", {
            position: "top-center",
            duration: 3000,
          });
        } else {
          if (this.user.type == "employee") {
            // console.log('employee');
            this.registerUserEmployee();
          }

          if (this.user.type == "shis") {
            // console.log('1');
            this.registerUserAdmin();
          }
        }
      },
      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/${this.register.localgovt.id}`)
          .then((response) => {
            this.wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/2683`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      fetchLgaOrigin() {
        this.axios
          .get(`/api/v1/auth/lga/${this.register.state_of_origin}`)
          .then((response) => {
            this.lga_states_origin = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/4`)
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response.data);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getOfficerDetails() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/OfficerDetails/${this.user.id}`)
          .then((response) => {
            this.OfficerDetails = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      registerUserAdmin() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/registerProvider", {
            nimc_number: this.register.nimc_number,
            firstname: this.register.firstname.toUpperCase(),
            lastname: this.register.lastname.toUpperCase(),
            middlename: this.register.middlename,
            email: this.register.email,
            phone_number: this.register.phone_number,
            type: this.register.type,
            sectorType: this.sector,
            sector: this.register.sector,
            agency_id: 4,
            provider_id: this.selected_provider
              ? this.selected_provider
              : this.register.provider_id,
            point_of_care: this.selected_provider_dependents
              ? this.selected_provider_dependents
              : this.register.point_of_care,
            state: "2683",
            special_need: this.register.special_need,
            role: 0,
            password: "euhler",
            localgovt: this.register.localgovt.id,
            ward: this.register.ward,
            blood: this.register.blood,
            dob: this.register.dob,
            address1: this.register.address,
            genotype: this.register.genotype,
            weight: this.register.weight,
            gender: this.register.gender,
            place_of_work: this.register.place_of_work.name,
            finger_print: this.register.finger_print,
            salary_number: this.register.salary_number,
            grade_level: this.register.grade_level,
            date_of_entry: this.register.date_of_entry,
            marital_status: this.register.marital_status,
            category_of_vulnerable_group:
              this.register.category_of_vulnerable_group,
            enrolled_by: this.user.id,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("Client added Successfully", {
              position: "top-center",
              duration: 3000,
            });
            let user_id = response.data.data.id;

            this.$router.push(`/client/${user_id}`);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            let response = error.response.data.errors;
            this.$toasted.error(`${JSON.stringify(response)}`, {
              position: "top-center",
              duration: 3000,
            });
          });
      },

      registerUserEmployee() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/registerProvider", {
            agency_id: this.user.institutional_id,
            nimc_number: this.register.nimc_number,
            firstname: this.register.firstname.toUpperCase(),
            lastname: this.register.lastname.toUpperCase(),
            middlename: this.register.middlename.toUpperCase(),
            email: this.register.email,
            phone_number: this.register.phone_number,
            type: this.register.type,
            sectorType: this.sector,
            sector: this.register.sector,
            special_need: this.register.special_need,
            provider_id: this.selected_provider
              ? this.selected_provider
              : this.register.provider_id,
            point_of_care: this.selected_provider_dependents
              ? this.selected_provider_dependents
              : this.register.point_of_care,
            state: "2683",
            role: 0,
            password: "jacobi",
            localgovt: this.register.localgovt.id,
            ward: this.register.ward,
            blood: this.register.blood,
            dob: this.register.dob,
            address1: this.register.address,
            genotype: this.register.genotype,
            means_of_id: this.register.means_of_id,
            state_of_origin: this.register.state_of_origin,
            lga_of_origin: this.register.lga_of_origin,
            gender: this.register.gender,
            place_of_work: this.register.place_of_work.name,
            finger_print: this.register.finger_print,
            salary_number: this.register.salary_number,
            grade_level: this.register.grade_level,
            date_of_entry: this.register.date_of_entry,
            marital_status: this.register.marital_status,
            category_of_vulnerable_group:
              this.register.category_of_vulnerable_group,
            enrolled_by: this.user.id,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            // this.getClients();
            this.$toasted.info("Client added Successfully", {
              position: "top-center",
              duration: 3000,
            });
            let user_id = response.data.data.id;
            this.$router.push(`/client/${user_id}`);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.$toasted.error(`User already Exist or Data Incorrect `, {
              position: "top-center",
              duration: 3000,
            });
          });
      },
      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/providerAgency/4`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getStates() {
        this.axios
          .get(`/api/v1/auth/states`)
          .then((response) => {
            this.states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProvidersByWards() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(
            `/api/v1/auth/providerAgencies/4/${this.register.localgovt.id}/${this.register.ward}`
          )
          .then((response) => {
            this.providers_wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
    created() {
      this.fetchLga();
      this.getStates();
      this.getMDAs();
      this.getProviders();
      this.getOfficerDetails();
    },
  };
</script>